import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { EditOutlined } from "@ant-design/icons";

import styled from "styled-components";
import { message, Form, Radio } from "antd";
// import { Space } from "antd";
import { GlassCard } from "components/App/styled";
import DateInput from "components/inputs/DateInput";
import Button from "components/buttons/Button";
import colors from "constants/palette";
import Table from "components/Tables/Table";

import ProductView from "pages/dashboard/Reports/Filters/Product";
import OrderView from "pages/dashboard/Reports/Filters/Order";
import AccountView from "pages/dashboard/Reports/Filters/Account";
import Fetch from "components/Fetch";
import { toMysqlDate } from "common";
import New from "./new";
import DeleteButton from "components/buttons/DeleteButton";

dayjs.calendar("jalali");

export default function DataController({ data, setData }) {
  const [form] = Form.useForm();

  const [type, setType] = useState(0);
  const [print, setPrint] = useState(0);

  function onSubmit(data) {
    console.log("data", data);
    Fetch.post(
      "/report",
      {
        type: "product",
        start_date: toMysqlDate(new Date(data.start_date)),
        end_date: toMysqlDate(new Date(data.end_date)),
      },
      (res) => {
        if (res.data) {
          setData(res.data);
        } else {
          res?.errors &&
            res?.errors.map((e) => {
              message.error(e);
            });
        }
      }
    );
  }

  return (
    <Container>
      <Form
        form={form}
        layout="vertical"
        style={{ direction: "rtl" }}
        //   requiredMark={requiredMark}
        onFinish={onSubmit}
        initialValues={{ end_date: dayjs(new Date(), { jalali: true }) }}
      >
        <Section>
          <Radio.Group
            options={[
              { label: "کالا", value: 0 },
              { label: "سفارش", value: 1 },
              { label: "حساب", value: 2 },
            ]}
            onChange={(e) => {
              setType(e.target.value);
            }}
            value={type}
            optionType="button"
            buttonStyle="solid"
          />
        </Section>
        <Section>
          {type === 0 ? (
            <ProductView data={0} key={0} />
          ) : type === 1 ? (
            <OrderView data={1} key={1} />
          ) : (
            <AccountView data={2} key={2} />
          )}
        </Section>
        <Section>
          <label style={{ marginLeft: 12 }}>از تاریخ</label>
          <Form.Item
            name="start_date"
            rules={[
              {
                required: true,
                message: "لطفا زمان را وارد کنید!",
              },
            ]}
          >
            <DateInput />
          </Form.Item>
          <label style={{ marginLeft: 12, marginRight: 12 }}>الی </label>{" "}
          <Form.Item
            name="end_date"
            rules={[
              {
                required: true,
                message: "لطفا زمان را وارد کنید!",
              },
            ]}
          >
            <DateInput />
          </Form.Item>
        </Section>
        <Button htmlType="submit" shape="round" color={colors.blue}>
          نمایش مقادیر
        </Button>
        <Button
          shape="round"
          color={colors.blue}
          style={{ marginRight: 12 }}
          onClick={() => {
            setData(null);

            setPrint(true);
          }}
          htmlType="submit"
        >
          لیست مقادیر
        </Button>
      </Form>
      {print && data ? (
        <New setOff={() => setPrint(false)}>
          <Table
            pagination={false}
            style={{ direction: "rtl" }}
            columns={tableHeaders}
            dataSource={data.map((item, index) => ({
              ...item,
              image: (
                <img
                  width="72"
                  height="72"
                  src={"https://picsum.photos/id/237/200/300"}
                  alt="تصویر کالا"
                  title="تصویر کالا"
                />
              ),

              key: index + 1,
            }))}
          />
        </New>
      ) : null}
    </Container>
  );
}
const Container = styled(GlassCard)`
  padding: 16px 32px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
`;
const Section = styled.div`
  display: flex;
  align-items: baseline;
`;
const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "تصویر",
    dataIndex: "image",
    key: "image",
    align: "center",

    width: "80px",
  },
  {
    title: "نام کالا",
    dataIndex: "title",
    key: "title",
    align: "center",

    width: "100px",
    ellipsis: true,
  },
  {
    title: "دسته بندی",
    dataIndex: "category",
    key: "category",
    align: "center",

    width: "80px",
  },
  {
    title: "برند",
    dataIndex: "brand",
    key: "brand",
    align: "center",

    width: "80px",
  },
  {
    title: "توضیحات",
    dataIndex: "description",
    key: "description",
    align: "center",
    ellipsis: true,

    width: "80px",
  },
  {
    title: "موجودی",
    dataIndex: "stock",
    key: "stock",
    align: "center",
    width: "80px",
  },
  {
    title: "قیمت",
    dataIndex: "price",
    key: "price",
    align: "center",
    width: "80px",
  },
];
